import http from 'conversations-http/clients/http';
import { registerQuery, useQuery } from 'data-fetching-client';
export const FIRST_PAGE = 0;
const GET_HELPDESK_TICKET_RULES = registerQuery({
  fieldName: 'helpdeskTicketRules',
  fetcher: () => {
    return http.get('conversations-tickets/v1/helpdesk-ticket-rules', {});
  }
});
export const useGetHelpdeskTicketRules = () => useQuery(GET_HELPDESK_TICKET_RULES);